import React, { useState } from 'react';
import classNames from 'classnames';
import moment from 'moment';

import { CalendlyEventButtonProps } from '../models/calendarModels';
import classes from '../../../styles/pages/calendar/_calendar-item.module.scss';
import { useAppData } from '../../../context/AppContext';
import CalendarSkeleton from './CalendarSkeleton';
import CalendlyEventInfo from './CalendlyEventInfo';
import BookedLeadsListModal from './BookedLeadsListModal';
import { CalendlyScheduledEventProps } from '../../../core/types/_models';

const CalendlyEventButton: React.FC<CalendlyEventButtonProps> = ({
  day,
  month,
  calendlyEventsData,
  isLoading,
  isCurrentDate,
}) => {
  const { setShowModalBackground } = useAppData();
  const [showBookedLeadsModal, setShowBookedLeadsModal] =
    useState<boolean>(false);

  const getMatchedEvents = () => {
    return calendlyEventsData.filter((event) => {
      const eventDate = moment(event.timing.start);
      return (
        eventDate.date() === day.date() &&
        eventDate.month() === day.month() &&
        eventDate.year() === day.year()
      );
    });
  };

  const matchedEvents = getMatchedEvents();
  const handleDateClick = () => {
    setShowModalBackground(true);
    setShowBookedLeadsModal(true);
  };

  const handleCloseBookedListModal = () => {
    setShowModalBackground(false);
    setShowBookedLeadsModal(false);
  };
  const isDayInCurrentMonth = (day: moment.Moment): boolean => {
    return day.month() === month;
  };

  const isButtonDisabled = (day: moment.Moment): boolean => {
    const isPastDay = day.isBefore(moment(), 'day');
    const isDayDisabled = !isDayInCurrentMonth(day);
    return isPastDay || isDayDisabled;
  };

  return (
    <>
      <div
        key={day.format('YYYY-MM-DD')}
        className={classNames('d-flex-center w-14_28 h-7rem', classes.week)}
      >
        <button
          className={classNames(
            `${isCurrentDate ? 'current-date' : ''} ${matchedEvents?.length === 0 ? '' : 'outline-1-1e75ff'}  calendar-day-block h-6rem`,
            classes.day,
            {
              [classes.disabled]: isButtonDisabled(day),
            }
          )}
          onClick={handleDateClick}
          //disabled={isButtonDisabled(day) || matchedEvents?.length === 0}
        >
          <span className="date-text">{day.date()}</span>
          {isLoading ? (
            <CalendarSkeleton />
          ) : (
            <CalendlyEventInfo matchedEvents={matchedEvents ?? []} />
          )}
        </button>
      </div>
      {showBookedLeadsModal && (
        <div className="d-flex-center p-fixed top-0 left-0 size-max z4">
          <BookedLeadsListModal
            onClose={handleCloseBookedListModal}
            matchedEvents={matchedEvents ?? null}
          />
        </div>
      )}
    </>
  );
};

export default CalendlyEventButton;
